import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';

import {
  LOAD_PREFERRED_SITE_LIST,
  LOAD_PREFERRED_SITE_LIST_SUCCESS,
  LOAD_PREFERRED_SITE_LIST_ERROR,
} from '../type';

const companySiteReducer = handleActions(
  new Map([
    [
      LOAD_PREFERRED_SITE_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            preferredSiteListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PREFERRED_SITE_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            preferredSiteListLoading: { $set: false },
          },
          preferredSiteList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_PREFERRED_SITE_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            preferredSiteListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default companySiteReducer;
